import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { useDataTableContext } from "@msuite/ui/table";
import React from "react";
import { Can } from "@/components/citadel";
import { useTeams } from "@/hooks/use-teams";
import { PersonioSyncModal } from "@/modals/integrations/personio-sync-modal";
import { AddUserModal } from "@/modals/users/add-user-modal";

export function UsersMenu() {
	/** Context */
	const { refetch } = useDataTableContext();
	const teamController = useTeams();

	/** Hooks */
	const { t } = useTranslation();
	const disclosure = useDisclosure();
	const addUserDisclosure = useDisclosure();

	/** Functions */
	// The modal stays open after a sync: its table shows what happened to each person, and a
	// failure is only fixable while the row that says why is still on screen.
	async function handleOnComplete() {
		await teamController?.refetch();
		await refetch?.();
	}

	/** Render */
	// Both entry points create organisation accounts, which the server gates with
	// `create User` (only admin and owner hold it by default). Hiding them for anyone else
	// keeps the interface from offering a path the server refuses — and the add-user form's
	// role field, which reads a `manage Permission`-gated endpoint, from rendering empty for a
	// caller who could not complete it anyway.
	return (
		<React.Fragment>
			<Can
				action="create"
				subject="User"
			>
				<Button
					icon={<Icon name="Plus" />}
					variant="white"
					onClick={addUserDisclosure.onOpen}
				>
					{t("users.add_user")}
				</Button>
				<Button
					icon={<Icon name="Blocks" />}
					variant="primary"
					onClick={disclosure.onOpen}
				>
					{t("integrations.personio_sync.title")}
				</Button>
			</Can>
			{disclosure.isOpen && (
				<PersonioSyncModal
					isOpen={disclosure.isOpen}
					onClose={disclosure.onClose}
					onComplete={handleOnComplete}
				/>
			)}
			{addUserDisclosure.isOpen && (
				<AddUserModal
					isOpen={addUserDisclosure.isOpen}
					onClose={addUserDisclosure.onClose}
					onComplete={refetch}
				/>
			)}
		</React.Fragment>
	);
}
